import { render, staticRenderFns } from "./sys_module_roles.vue?vue&type=template&id=646dcc2e&scoped=true&"
import script from "./sys_module_roles.vue?vue&type=script&lang=js&"
export * from "./sys_module_roles.vue?vue&type=script&lang=js&"
import style0 from "./sys_module_roles.vue?vue&type=style&index=0&id=646dcc2e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646dcc2e",
  null
  
)

export default component.exports